import { CurrencyFormatterPipe } from './../../pipes/currency-formatter/currency-formatter.pipe';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Mise } from '../../models/mise.model';
import { MISE_LIST, MISEDEBASE_LIST } from '../../sample-data/mockup-data';
import { TranslateModule } from '@ngx-translate/core';
import { Game } from '../../models/game.model';
import { ConfigService } from '../../services/config/config.service';
import { MatRippleModule } from '@angular/material/core';
import { stakeSelectRippleOptions } from '../../constants/ripple-options.constant';

@Component({
  selector: 'app-mise',
  imports: [TranslateModule, MatRippleModule, CurrencyFormatterPipe],
  templateUrl: './mise.component.html',
  styleUrl: './mise.component.scss',
})

export class MiseComponent {
  private _game: Partial<Game> = {};
  @Output() selectGameAmount = new EventEmitter<{mise: number, coefficient: number}>();
  @Input()
   set game(value: Partial<Game>) {
      this._game = value;
      this.generateStakes();
    };
  @Input() set stake(value: number) {
    const mise = this.misesDeBase.find((m) => m.montant === value) || this.misesSupplemetaires.find((m) => m.montant === value);
    if(!!mise)
    this.selectionnerMise(mise!)
  };
  rippleOptions = stakeSelectRippleOptions;
  constructor(private readonly configService: ConfigService) {}

  get currency() {
    return this.configService.currency;
    }

  get game() {
    return this._game;
  }
  get stepNumber() {
    return 3;
  }

  misesDeBase: Mise[] = [];
  misesSupplemetaires: Mise[] = [];
  afficherToutesLesMises = false;

  selectionnerMise(mise: Mise) {
    this.misesDeBase.forEach((m) => (m.selectionne = m.montant === mise.montant));
    this.misesSupplemetaires.forEach((m) => (m.selectionne = m.montant === mise.montant));
    this.selectGameAmount.emit({mise: mise.montant, coefficient: mise.coef});
  }

  toggleAffichage() {
    this.afficherToutesLesMises = !this.afficherToutesLesMises;
  }

generateStakes() {
    //Get the game
    let coefficient = this._game.maxCoefficient ?? 0;
    let stake = this._game.baseStake ?? 0;
    // Generate Mise
    this.misesSupplemetaires = [];

    for (let i = 1; i <= coefficient; i++) {
      this.misesSupplemetaires.push({
        coef: i,
        montant: stake * i,
        selectionne: false,
      });
    }

    this.misesDeBase = this.misesSupplemetaires.slice(0,6);
  }

}
